// Add your custom JS here.
import counterUp from 'counterup2'

jQuery( document ).ready(function( $ ) {


    $('.counter').counterUp({
        delay: 10,
        time: 1000
    });

   if(!(Cookies.get('pum-institutional') || Cookies.get('pum-retail'))){
        //show popup
        $('#pum-btn').click();
   }
   else {
        if ( $('body').hasClass('home')) {
            $('#keynote-btn').click();
        }
    }

  $( "#pum-disagree" ).on( "click", function() {
        $("#pum-warning").removeClass('d-none');
   });

    $( "#pum-institutional" ).on( "click", function() {
        Cookies.set('pum-institutional', 'true', { expires: 7 });
        if ( $('body').hasClass('home')) {
            $('#keynote-btn').click();
        }
    });

    $( "#pum-retail" ).on( "click", function() {
        Cookies.set('pum-retail', 'true', { expires: 7 });
        if ( $('body').hasClass('home')) {
            $('#keynote-btn').click();
        }
    });

    $( "#launch-keynote" ).on( "click", function() {
        window.open("https://youtu.be/gZ5IpUEHNCQ?si=upMqBBrnEDfrYk9w", '_blank');
    });

   

   
    $( "#vision-btn" ).on( "click", function() {
        $("#core-values-btn").addClass('btn-light blue');
        $("#core-values-btn").removeClass('btn-primary');

        $("#vision-btn").addClass('btn-primary');
        $("#vision-btn").removeClass('btn-light blue');
    });

    $( "#core-values-btn" ).on( "click", function() {
        $("#core-values-btn").removeClass('btn-light blue');
        $("#core-values-btn").addClass('btn-primary');

        $("#vision-btn").removeClass('btn-primary');
        $("#vision-btn").addClass('btn-light blue');
    });

   

  // Code that uses jQuery's $ can follow here.
  $( ".toggle-icon" ).on( "click", function() {
        $(this).next().slideToggle('slow');
        console.log($(this).data("open"));
        if($(this).data("open")) {
            $(this).attr("src" , "/wp-content/themes/mirae/img/Plus_Circle_Filled.svg");
            $(this).data("open", false);
        }
        else {
            $(this).attr("src" , "/wp-content/themes/mirae/img/Minus_Circle_Filled.svg");
            $(this).data("open", true);
        }
  } );



jQuery.fn.isInViewport = function (offset) {
    var elementTop = jQuery(this).offset().top;
    var elementBottom = elementTop + jQuery(this).outerHeight();
    var viewportTop = jQuery(window).scrollTop();
    var viewportBottom = viewportTop + jQuery(window).height();
    return elementBottom > viewportTop && elementTop < viewportBottom - jQuery(this).height()+offset;
};
jQuery(window).bind('scroll', function(){
    jQuery('.item_history .col-sm-6').each( function(){
        if (jQuery(this).isInViewport(0)) {
            jQuery(this).addClass('on');
        }

    })
});

jQuery('.item_history .col-sm-6').each( function(){
    if (jQuery(this).isInViewport(0)) {
        jQuery(this).addClass('on');
    }

});

$('.vc_tta-panels-container .vc_tta-panel-heading').click(function (e) {
    e.preventDefault();
    $(this).toggleClass('open')
    $(this).siblings('.vc_tta-panel-body').stop().slideToggle(300);
});


$(document).on("click", ".open-teamMemberModal", function () {
    var biodata = $(this).data('bio');
    var biopath = $(this).data('path');
    var bioName = $(this).data('bioname');
    var bioPosition = $(this).data('bioposition');
    $("#bio-modal-data").text( biodata );
    $('#bio-modal-pic').attr('src', biopath);
    $("#bio-modal-name").text( bioName );
    $('#bio-modal-position').text(bioPosition);
});


});
